import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import config from "config";
import { CustomerConfig } from "./../../src/Dashboard/actions/apiActions";
import { initialState } from "./customersInitialState";

// Thunk functions
export const fetchCustomers = createAsyncThunk("customers/fetchCustomers", async (data) => {
  const response = await CustomerConfig.get(config.CONFIGURATION_URL, data);

  return response.customers;
});

const customersSlice = createSlice({
  name: "customers",
  initialState,
  reducers: {
    setSelectedSensorSite(state, action) {
      console.log("setSelectedSensorSite action", action);
      const sensorSite = action.payload;
      state.selectedSensorSite = sensorSite;
    },
    setSelectedSystems(state, action) {
      const { devices, path } = action.payload;
      if (path === "map") {
        // Should key by customerId but it's not unique now
        const onMapCustomerIndexes = [];
        devices.forEach((device) => {
          const index = state.list.findIndex((cus) => cus.customerName === device.customerName);
          onMapCustomerIndexes.push(index);
        });
        state.list.forEach((cus, idx) => {
          const isOnMap = onMapCustomerIndexes.includes(idx);
          state.list[idx] = isOnMap ? { ...cus, onMap: true } : { ...cus, onMap: false };
        });

        state.selectedMapSystems = devices;
      } else {
        state.selectedSystems = devices;
      }
    },
    setCustomersOnMap(state, action) {
      const { customerId, customerName, onMap, devices } = action.payload;
      const index = state.list.findIndex((cus) => cus.customerId === customerId && cus.customerName === customerName);
      state.list[index] = action.payload;

      if (onMap) {
        const devicesWithCustomerName = devices.map((dev) => ({
          ...dev,
          customerId,
          customerName,
        }));
        state.selectedMapSystems.push(...devicesWithCustomerName);
      } else {
        // Should filter by customerId but it's not unique now
        state.selectedMapSystems = state.selectedMapSystems.filter((sys) => sys.customerName !== customerName);
      }
    },
    changeEditViewState(state, action) {
      state.createCustomerView = false;
      const siteName = action.payload?.siteName ?? action.payload;
      const deviceId = action.payload?.deviceId ?? "";

      if (state.editView.selectedSiteName === siteName && !deviceId) {
        // Toggle off only when clicking the same site with no device
        state.editView.selectedSiteName = "";
        state.editView.editViewEnabled = false;
        state.editView.selectedDeviceId = "";
      } else if (state.editView.selectedDeviceId === deviceId && deviceId) {
        // Clicking the same device deselects it, but keeps site open
        state.editView.selectedDeviceId = "";
      } else {
        state.editView.selectedSiteName = siteName;
        state.editView.editViewEnabled = true;
        state.editView.selectedDeviceId = deviceId;
      }
    },

    emptyEditViewState(state) {
      state.editView.selectedSiteName = "";
      state.editView.editViewEnabled = false;
      state.editView.selectedDeviceId = "";
    },

    changeCreateCustomerViewState(state) {
      if (state.createCustomerView === false) {
        state.createCustomerView = true;
        state.editView.editViewEnabled = false;
        state.editView.selectedSiteName = "";
      } else {
        state.createCustomerView = false;
      }
    },

    changeCreateDeviceViewState(state) {
      state.createDeviceView = !state.createDeviceView;
    },

    updateCustomersList(state, action) {
      state.list = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomers.pending, (state, action) => {
        state.isFetchingCustomers = true;
      })
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        state.list = action.payload.map((c) => ({
          ...c,
          onMap: false,
        }));
        state.isFetchingCustomers = false;
      })
      .addCase(fetchCustomers.rejected, (state, action) => {
        state.isFetchingCustomers = false;
      });
  },
});

export const {
  setSelectedSensorSite,
  setSelectedSystems,
  setCustomersOnMap,
  changeEditViewState,
  changeCreateCustomerViewState,
  changeCreateDeviceViewState,
  updateCustomersList,
  emptyEditViewState,
} = customersSlice.actions;

export default customersSlice.reducer;
